import React from 'react';
import SelectTestPresentation from './SelectTestPresentation';

export default class SelectTest extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { typeTest, tests, value, name, onChange } = this.props;

        return (
            <SelectTestPresentation
                onChange={onChange}
                typeTest={typeTest}
                tests={tests}
                value={value}
                name={name}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SelectTest/index.js